<ion-app>
    <!-- Fullscreen Loading Overlay -->
    @if (isGlobalLoading$ | async) {
        <app-loading-container [fullscreen]="true" [background]="true" [backdropBlur]="true"></app-loading-container>
    }

    <!-- Main Content -->
    <ion-content>
        <div class="app-root-container"
             [class.logged-in]="isLoggedIn$ | async">
            <!-- Sidenav -->
            <app-sidenav [isOpen]="isSidenavOpen()" (toggleSidenav)="toggleSidenav()" (closeSidenav)="closeSidenav()">
            </app-sidenav>

            <div class="content">
                <!-- Global Header - only show for authenticated users on non-public routes -->
                @if ((isAuthenticated$ | async) && !(isPublicRoute$ | async)) {
                    <div class="global-header">
                        <app-control-header></app-control-header>
                    </div>
                }

                <div class="content-router">
                    <div class="scrollable-content">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </ion-content>
</ion-app>
